import { withCents } from './format/with_cents';
import { withoutCents } from './format/without_cents';

export const formatToCurrency = (
    value,
    currencyIsoCode,
    noHTML = false,
    inCents = false,
    currencySetupOverrides = {}
) =>
    inCents
        ? withCents(value, currencyIsoCode, noHTML, currencySetupOverrides)
        : withoutCents(value, currencyIsoCode, noHTML, currencySetupOverrides);

export default formatToCurrency;
